
import React from 'react';
import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { SecondaryTextSmBold,  } from "atoms";


const template = styled.div`
  background: white;
  padding: 5px 10px;
  border-radius: 15px;
`;


export default Molecule({
  template: template,
  atoms: [
    {
      component: SecondaryTextSmBold,
      name: 'Value',
      displayValue: ({ value }) => value ?? "",
      displayState: ({ color }) => ({ color })
    },

  ]
})